import { useNavigate } from 'react-router-dom';
import { ProgressBar } from './Step1';
import { Check, Sparkles } from 'lucide-react';

export default function OnboardingStep4() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center px-4 py-20">
      <div className="w-full max-w-2xl">
        <ProgressBar step={4} />
        <div className="flex items-center gap-2 mb-2">
          <Sparkles size={20} className="text-emerald-400" />
          <h1 data-testid="onboarding-step4-title" className="text-2xl md:text-3xl font-bold text-white font-mono section-marker">We recommend Professional</h1>
        </div>
        <p className="text-zinc-500 text-sm mb-8">Based on your selections, here's the best plan for you.</p>

        <div className="bg-emerald-500/5 border border-emerald-500/30 rounded-sm p-8 mb-6 shadow-[0_0_30px_rgba(16,185,129,0.08)]">
          <div className="flex items-start justify-between mb-6">
            <div>
              <h2 className="text-white font-mono font-bold text-2xl mb-1">Professional</h2>
              <p className="text-zinc-500 text-sm">Ideal for teams, agencies, and power users.</p>
            </div>
            <div className="text-right">
              <span className="text-4xl font-mono font-bold text-white">$29</span>
              <span className="text-zinc-500 font-mono text-sm">/mo</span>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            {['2-10 Agents', '4 vCPU / 8GB RAM', '100GB NVMe SSD', 'RDP/SSH Access', 'Daily Backups', 'Unlimited Skills', 'Priority Support', 'Cost Monitoring'].map((f, i) => (
              <div key={i} className="flex items-center gap-2 text-sm text-zinc-400">
                <Check size={14} className="text-emerald-400 flex-shrink-0" /> {f}
              </div>
            ))}
          </div>
        </div>

        <button
          data-testid="onboarding-choose-different"
          onClick={() => navigate('/pricing')}
          className="w-full text-center text-sm font-mono text-zinc-500 hover:text-zinc-300 py-3 border border-zinc-800 rounded-sm hover:border-zinc-700 transition-all mb-4"
        >
          Choose a different plan
        </button>

        <div className="bg-[#0A0A0A] border border-zinc-800 rounded-sm p-6 mb-8">
          <div className="flex items-center justify-between mb-4">
            <span className="text-sm font-mono text-zinc-400">Estimated monthly cost</span>
            <span className="text-lg font-mono font-bold text-white">$29.00</span>
          </div>
          <div className="flex items-center justify-between text-xs text-zinc-600">
            <span>LLM API costs are separate (you bring your own keys)</span>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <button data-testid="onboarding-back-4" onClick={() => navigate('/onboarding/step-3')} className="text-sm font-mono text-zinc-500 hover:text-zinc-300 transition-colors">Back</button>
          <div className="flex gap-3">
            <button data-testid="onboarding-trial-first" onClick={() => navigate('/dashboard')} className="border border-zinc-700 text-zinc-300 font-mono text-sm rounded-sm px-6 py-3 hover:border-zinc-500 transition-all">
              Trial First
            </button>
            <button data-testid="onboarding-start-trial" onClick={() => navigate('/dashboard')} className="bg-emerald-500 text-black font-mono font-bold text-sm rounded-sm px-8 py-3 hover:bg-emerald-400 transition-all click-scale shadow-[0_0_15px_rgba(16,185,129,0.3)]">
              Start 14-Day Free Trial
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
